import React from 'react'
import { Link, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useGetSchoolUnitQuery } from '../../store/api/schoolAdminApi'
import { useSchoolFilters } from '../../components/school/SchoolLayout'
import DateRangeBar from '../../components/school/DateRangeBar'
import { formatDate } from '../../components/school/SchoolUi'

const SchoolUnitDetail: React.FC = () => {
  const { t } = useTranslation('school')
  const { requestId } = useParams()
  const { filters } = useSchoolFilters()
  const { data, isLoading } = useGetSchoolUnitQuery({ requestId: Number(requestId), ...filters })

  if (isLoading) return <div className="text-gray-500">{t('common.loading')}</div>
  if (!data) return <div className="text-gray-500">{t('units.empty')}</div>

  return (
    <div className="space-y-6">
      <div>
        <Link to={`/pending/classes/${data.unit.projectId}`} className="text-sm text-blue-600 hover:underline">{t('units.back')}</Link>
        <h1 className="text-2xl font-bold text-gray-900 mt-2">{data.unit.name}</h1>
        <p className="text-gray-600">{t('units.detailTitle')} · {data.unit.className}</p>
      </div>
      <DateRangeBar showClassFilter={false} />
      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
        <div className="px-5 py-4 border-b"><h2 className="font-semibold">{t('units.activities')}</h2></div>
        {!(data.activities || []).length ? (
          <div className="p-6 text-gray-500">{t('units.empty')}</div>
        ) : (
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-3 py-2 text-left text-xs uppercase text-gray-500">{t('units.columns.activity')}</th>
                <th className="px-3 py-2 text-left text-xs uppercase text-gray-500">{t('units.columns.teacher')}</th>
                <th className="px-3 py-2 text-left text-xs uppercase text-gray-500">{t('units.columns.date')}</th>
                <th className="px-3 py-2 text-left text-xs uppercase text-gray-500">{t('units.columns.assigned')}</th>
                <th className="px-3 py-2 text-left text-xs uppercase text-gray-500">{t('units.columns.participated')}</th>
                <th className="px-3 py-2 text-left text-xs uppercase text-gray-500">{t('units.columns.aiSessions')}</th>
                <th className="px-3 py-2 text-left text-xs uppercase text-gray-500">{t('units.columns.avgInteractions')}</th>
                <th className="px-3 py-2 text-left text-xs uppercase text-gray-500">{t('units.columns.followUps')}</th>
                <th className="px-3 py-2 text-left text-xs uppercase text-gray-500">{t('units.columns.reflections')}</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {data.activities.map((a: any) => (
                <tr key={a.id}>
                  <td className="px-3 py-3 text-sm">
                    <Link to={`/pending/activities/${a.id}`} className="text-blue-600 hover:underline">{a.name}</Link>
                  </td>
                  <td className="px-3 py-3 text-sm">{a.teacherName || t('common.na')}</td>
                  <td className="px-3 py-3 text-sm">{formatDate(a.createdAt)}</td>
                  <td className="px-3 py-3 text-sm">{a.assignedStudents}</td>
                  <td className="px-3 py-3 text-sm">{a.participatedStudents}</td>
                  <td className="px-3 py-3 text-sm">{a.aiSessions}</td>
                  <td className="px-3 py-3 text-sm">{a.avgInteractions}</td>
                  <td className="px-3 py-3 text-sm">{a.followUpQuestions}</td>
                  <td className="px-3 py-3 text-sm">{a.reflectionCompleted ? t('activities.yes') : t('activities.no')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}

export default SchoolUnitDetail
